import { type ComponentProps } from 'react'

import Svg from '~/shared/assets/Svg'

interface Props extends ComponentProps<typeof Svg> {}

const Close = ({ color = '#838685', ...rest }: Props) => {
  return (
    <Svg
      width={36}
      height={36}
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M9.6 28.5L7.5 26.4L15.9 18L7.5 9.6L9.6 7.5L18 15.9L26.4 7.5L28.5 9.6L20.1 18L28.5 26.4L26.4 28.5L18 20.1L9.6 28.5Z"
        fill={color}
      />
    </Svg>
  )
}

export default Close
